import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { clientInformation } from "@discovery/common-dplus/lib/device-info";
import { envBrowser } from "@discovery/maestro-env-browser";
import * as E from "fp-ts/Either";
import * as App from "@discovery/maestro";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { blueshiftContentImpressionEvent } from "@discovery/common-dplus/lib/blueshift";
import { createRef } from "react";
import { _Video, _Channel } from "./optics/player";
import { _VideoDetailsProps, _VideoDetails, _Video2Genre, _PrimaryChannelTitleVideo, } from "./optics/video-details";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { updateGlobalState, useEffect, useGlobalState, useState, } from "@discovery/common-dplus/lib/hooks";
import { _Config, _IsUserPremiumFromPartners, _videoId, } from "@discovery/common-dplus/lib/state";
import * as styles from "./styles.css";
import { useAds, useUser } from "../../utils/hooks";
import * as Videos from "@discovery/sonic-api-ng/lib/api/content/videos";
import VideoPagePlayer from "../../components/molecules/video-details";
import { VideoDetailsView } from "../../components/molecules/video-details/video-details-view";
import { navigateTo } from "../../utils/common";
const getProps = (data) => {
    const streamIDM = M.alt(Fold.preview(_Video, data), Fold.preview(_Channel, data));
    const videoDetailsPropsM = Fold.preview(_VideoDetailsProps, data);
    const video = M.fromMaybe(streamIDM, {
        id: "",
        type: "VIDEO",
        instigator: "MANUAL",
    });
    const updateGlobalVideoId = updateGlobalState(_videoId);
    updateGlobalVideoId((_videoId) => video.id);
    const primaryChannelTitleM = Fold.preview(_PrimaryChannelTitleVideo, data);
    const genre = Fold.toArray(_Video2Genre, data);
    const videoPropsM = M.liftA2((videoProps) => (streamId) => {
        const props = Object.assign(Object.assign({}, videoProps), { streammIdForPlayer: streamId.id });
        return props;
    }, videoDetailsPropsM, streamIDM);
    return {
        streamIDM,
        videoPropsM,
        genre,
        primaryChannelTitleM,
    };
};
const VideoPageForShow = ({ streamIDM, videoPropsM, genre, environment, primaryChannelTitleM, }) => {
    const [configM] = useGlobalState(_Config);
    const { enableAds } = useAds();
    const { isPremiumUser, userId } = useUser();
    const adsM = M.chain((x) => x.ads, configM);
    const vastTagM = M.chain((x) => x.vastTag, adsM);
    const shortvastTagM = M.chain((x) => x.shortsVastTag, adsM);
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    const ispremiumSubscriber = isPremiumUser || isPremiumUserFromPartner;
    const imaAdsConfig = {
        vastTag: M.fromMaybe(vastTagM, ""),
        shortsVastTag: M.fromMaybe(shortvastTagM, ""),
        enableAds: isPremiumUserFromPartner ? false : enableAds,
    };
    const stickyVideo = createRef();
    const [videoDetailsView, setVideoDetailsView] = useState(videoPropsM);
    const getVideoDetails = (videoId) => {
        const appendQueryParams = `${videoId}?decorators=viewingHistory,isFavorite&include=images,show,season`;
        const postRequest = Videos.Endpoints.getVideo(appendQueryParams);
        App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), environment), { clientInformation: clientInformation })).then(E.fold((_exception) => {
            /* handle exception here */
        }, (response) => {
            const getVideoDetailsM = Fold.preview(_VideoDetails, response);
            setVideoDetailsView(getVideoDetailsM);
        }));
    };
    const genres = genre.map((genreM) => {
        const genre = M.fromMaybe(genreM, "");
        return genre;
    });
    const videoProps = M.fromMaybe(videoPropsM, {});
    const title = M.fromMaybe(videoProps.titleM, "");
    const videoId = videoProps.id;
    const seasonNo = M.fromMaybe(videoProps.seasonNumberM, 1);
    const episodeNo = M.fromMaybe(videoProps.episodeNumberM, 1);
    const videoType = M.fromMaybe(videoProps.videoTypeM, "");
    const primaryChannelTitle = M.fromMaybe(primaryChannelTitleM, "");
    const showName = M.fromMaybe(videoProps.showNameM, "");
    const alternateId = videoProps.alternateId ? videoProps.alternateId : "";
    const sendAnalyticsForBlueshift = () => {
        blueshiftContentImpressionEvent(userId, "video", videoId, primaryChannelTitle, alternateId, "", title, videoType, seasonNo.toString(), episodeNo.toString(), showName, genres);
    };
    useEffect(() => {
        const stickyVideoPlayer = stickyVideo.current;
        sendAnalyticsForBlueshift();
        if (stickyVideoPlayer && window.innerWidth < 700) {
            const videoPlayer = document.getElementById("isPlayingVideo");
            const height = videoPlayer === null || videoPlayer === void 0 ? void 0 : videoPlayer.offsetHeight;
            stickyVideoPlayer.style.paddingTop =
                height && height > 0 ? `${height && height}px` : "230px";
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.playerBackground },
            React.createElement("div", { className: styles.videoContainer },
                React.createElement(RenderMaybe, null, M.map((item) => (React.createElement("div", { className: styles.descWrapper },
                    React.createElement(VideoPagePlayer, Object.assign({}, item, { imaAdsConfig: imaAdsConfig, streamIDM: streamIDM, read: environment, getVideoDetails: getVideoDetails })))), videoPropsM)),
                React.createElement("div", { ref: stickyVideo, className: styles.wrapper },
                    !ispremiumSubscriber && (React.createElement("div", { className: styles.goPremiumContainer },
                        React.createElement("span", { className: styles.subscribeText }, "Subscribe now and go 100% Ad Free"),
                        React.createElement("div", { className: styles.goPremiumCta, onClick: () => {
                                navigateTo("/go-premium-web");
                            }, id: "#goPremium" },
                            React.createElement("span", { className: styles.goPremiumCtaText }, "GO PREMIUM")))),
                    React.createElement(VideoDetailsView, { videoPropsM: videoDetailsView, read: environment, genres: genres }))),
            React.createElement("div", { className: styles.separator }))));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, VideoPageForShow);

